<template>
  <div class="pwa-install-prompt__container is-active">
    <button class="pwa-install-prompt__overlay" @click="close">{{ $t("ui.close") }}</button>
    <div class="pwa-install-prompt">
      <div class="pwa-install-prompt__content" style="padding-bottom: 0;" v-if="message">
        <p class="pwa-install-prompt__text" style="margin: 16px 0 0;">{{ message }}</p>
      </div>
      <div class="pwa-install-prompt__icon__container">
        <img class="pwa-install-prompt__icon" src="@/assets/img/icon.png" alt="Edifi Lite">
        <img style="display:none;" class="pwa-install-prompt__icon" src="@/assets/img/icon-alt.png" alt="Edifi Lite"> <!-- leave this alone, included for proper assets packaging -->
      </div>
      <div class="pwa-install-prompt__content">
        <h3 class="pwa-install-prompt__title">{{ $t("a2hs.install_app") }}</h3>
        <div class="pwa-install-prompt__text">
          <p>{{ $t("a2hs.install_app_benefit") }}</p>
          <a href="https://play.google.com/store/apps/details?id=app.edifi.cordova" target="_blank">
            <img style="width: 180px;" class="non-ios-only" src="@/assets/img/playstore.png" alt="Get Edifi On Google Play">
          </a>
          <a href="https://apps.apple.com/us/app/edifi-app/id1493412618?ls=1" target="_blank">
            <img style="width: 180px;" class="non-android-only" src="@/assets/img/appstore.png" alt="Download Edifi On the App Store">
          </a>
        </div>
        <h3 class="pwa-install-prompt__subtitle">{{ $t("a2hs.install_lite") }}</h3>
        <p class="pwa-install-prompt__text">{{ $t("a2hs.install_lite_benefit") }}</p>
        <p class="pwa-install-prompt__guide ios-only" v-if="!notAvailable">{{ $t("a2hs.ios_step1") }} <svg class="pwa-install-prompt__guide__icon" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Share</title><path fill="#007AFF" d="M48.883,22.992L61.146,10.677L61.146,78.282C61.146,80.005 62.285,81.149 64,81.149C65.715,81.149 66.854,80.005 66.854,78.282L66.854,10.677L79.117,22.992C79.693,23.57 80.256,23.853 81.114,23.853C81.971,23.853 82.534,23.57 83.11,22.992C84.25,21.848 84.25,20.125 83.11,18.981L65.997,1.794C65.715,1.511 65.421,1.215 65.139,1.215C64.563,0.932 63.718,0.932 62.861,1.215C62.579,1.498 62.285,1.498 62.003,1.794L44.89,18.981C43.75,20.125 43.75,21.848 44.89,22.992C46.029,24.149 47.744,24.149 48.883,22.992ZM103.936,35.32L81.114,35.32L81.114,41.053L103.936,41.053L103.936,121.27L24.064,121.27L24.064,41.053L46.886,41.053L46.886,35.32L24.064,35.32C20.928,35.32 18.355,37.904 18.355,41.053L18.355,121.27C18.355,124.419 20.928,127.003 24.064,127.003L103.936,127.003C107.072,127.003 109.645,124.419 109.645,121.27L109.645,41.053C109.645,37.891 107.072,35.32 103.936,35.32Z"></path></svg> {{ $t("a2hs.ios_step2") }}</p>
        <p class="pwa-install-prompt__guide android-only" v-if="!notAvailable"><button class="button--cta" @click="install" :disabled="installDisabled">{{ $t("a2hs.android_step1") }}</button></p>
        <p class="pwa-install-prompt__guide" v-if="notAvailable">{{ $t("a2hs.lite_not_avail") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message', 'notAvailable'],
  data() {
    return {
      installDisabled: false,
    };
  },

  methods: {
    install() {
      this.installDisabled = true;
      this.$a2hs.install();
    },

    close() {
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    },
  },
};
</script>